import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../components/themeimg/INWI_LOGO.png";
import { baseUrl, getHeaders } from '../config/config';
import Loader from './Loader';
import './style/scoreboard.css';
import backArrow from "./themeimg/dtLite/back_menu_arrow.png";
import backgroundImage from "./themeimg/dtLite/page_bg_image.jpg";
import nodata from "./themeimg/dtLite/no_leaderboard_icon.png";
import rankIcon from "./themeimg/dtLite/rank_icon.png";

export default function PreviousWinner({ }) {
  const [sbData, setSbData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [type, setType] = useState("daily");
  const [monthData, setMonthData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [weekData, setWeekData] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState("");
  const [status, setStatus] = useState("");

  const navigate = useNavigate();
  const msisdn = localStorage.getItem("msisdn") || localStorage.getItem("msisdn2");

  function changeToStar(num) {
    const temp = num.split('');
    for (let i = 6; i < temp.length; i++) {
      temp[i] = "X";
    }
    return temp.join('');
  }

  const gotoHome = () => {
    navigate('/home');
  }

  // Get Months & Weeks
  const MonthData = async (isMonthly = false) => {
    setLoader(true);
    const response = await axios({
      method: 'post',
      url: baseUrl + 'monthList',
      headers: getHeaders(),
    })

    // Simulated API
    // const data = [
    //   {
    //     "name": "Juillet–Août'2025",
    //     "month_date": {
    //       "start_date": "2025-07-21",
    //       "end_date": "2025-08-17"
    //     },
    //     "weeks": [
    //       { "name": "1 week", "weekDate": { "start_date": "2025-07-21", "end_date": "2025-07-27" } },
    //       { "name": "2 week", "weekDate": { "start_date": "2025-07-28", "end_date": "2025-08-03" } },
    //       { "name": "3 week", "weekDate": { "start_date": "2025-08-04", "end_date": "2025-08-10" } },
    //       { "name": "4 week", "weekDate": { "start_date": "2025-08-11", "end_date": "2025-08-17" } }
    //     ]
    //   },
    //   {
    //     "name": "Août–Septembre'2025",
    //     "month_date": {
    //       "start_date": "2025-08-18",
    //       "end_date": "2025-09-14"
    //     },
    //     "weeks": [
    //       { "name": "1 week", "weekDate": { "start_date": "2025-08-18", "end_date": "2025-08-24" } },
    //       { "name": "2 week", "weekDate": { "start_date": "2025-08-25", "end_date": "2025-08-31" } },
    //       { "name": "3 week", "weekDate": { "start_date": "2025-09-01", "end_date": "2025-09-07" } }
    //     ]
    //   },
    //   {
    //     "name": "Septembre'2025",
    //     "month_date": {
    //       "start_date": "2025-09-15",
    //       "end_date": "2025-09-30"
    //     },
    //     "weeks": [
    //       { "name": "1 week", "weekDate": { "start_date": "2025-09-15", "end_date": "2025-09-21" } },
    //       { "name": "2 week", "weekDate": { "start_date": null, "end_date": null } }
    //     ]
    //   }
    // ];

    setMonthData(response.data);

    if (response.data.length > 0) {
      const firstMonth = response.data[0];
      const firstWeek = firstMonth.weeks[0];
      setSelectedMonth(firstMonth.name);
      setWeekData(firstMonth.weeks);
      setSelectedWeek(firstWeek.name);

      if (isMonthly) {

        const endDateUTC = new Date(firstMonth.month_date.end_date + "T23:59:59Z");
        const currentUTC = new Date();

        if (currentUTC < endDateUTC) {
          setLoader(false);
          setSbData([]);
          return;
        } else {
          scoreBoard(firstMonth.month_date.start_date, firstMonth.month_date.end_date);
        }
      } else {
        scoreBoard(firstWeek.weekDate.start_date, firstWeek.weekDate.end_date);
      }
    }
    console.log("::::::::::loader false in montyl data:::::::::::", loader)
    // setLoader(false);
  };

  const scoreBoard = async (startDate = "", endDate = "") => {
    console.log(":::::scroeboard lodaer true,,,,,", loader)
    setLoader(true);
    const response = await axios({
      method: 'post',
      url: baseUrl + 'prevWinners',
      data: {
        view_type: type,
        ...(type !== "daily" && startDate && endDate && {
          start_date: startDate,
          end_date: endDate
        })
      },
      headers: getHeaders(),
    });

    setSbData(response?.data);
    setStatus(response?.data?.status);
    console.log(":::::scroeboard lodaer false in end,,,,,", loader)
    setLoader(false);
  };
  const handleMonthChange = (monthName) => {
    const selected = monthData.find(m => m.name === monthName);
    if (!selected) return;

    setSelectedMonth(monthName);
    setWeekData(selected.weeks);
    setSelectedWeek(selected.weeks[0].name);

    if (type === "monthly") {
      scoreBoard(selected.month_date.start_date, selected.month_date.end_date);
    } else if (type === "weekly") {
      const firstWeek = selected.weeks[0];
      scoreBoard(firstWeek.weekDate.start_date, firstWeek.weekDate.end_date);
    }
  };

  const handleWeekChange = (week) => {
    setSelectedWeek(week.name);
    if (type === "weekly") {
      scoreBoard(week.weekDate.start_date, week.weekDate.end_date);
    }
  };

  useEffect(() => {
    if (type === "weekly") {
      MonthData(false); // weekly → load first week
    } else if (type === "monthly") {
      MonthData(true); // monthly → load full month
    } else if (type === "daily") {
      setSelectedMonth("");
      setSelectedWeek("");
      scoreBoard();
    }
  }, [type]);

  return (
    <>
      {loader ? <Loader /> :
        <div className='scoreboard-container'
          style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <div className='container scoreboard-bg'>
            <div className='container-nav-bar'>
              <div className='nav-bar'>
                <div className='back-arrow'>
                  <div className='back-arrow-button' onClick={gotoHome}>
                    <img src={backArrow} alt="back" />
                  </div>
                </div>
                <div className='header-hosted-page'>Gagnants Précedant</div>
              </div>
            </div>

            {/* Month Dropdown */}
            <div className='w-full bg-[#FFCC00]'>
              {(type === "monthly" || type === "weekly") && (
                <div className="w-[98%] mx-auto mt-0 ">
                  <select
                    className="w-full px-4 py-2 text-black border-2 border-black rounded-md cursor-pointer"
                    value={selectedMonth || ""}
                    onChange={(e) => handleMonthChange(e.target.value)}
                  >
                    {monthData.map((item) => (
                      <option key={item.name} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>

            {/* Tabs */}
            <div className='w-[98%] flex justify-center border-2 py-1 mx-auto border-[#FFCC00] rounded-md px-2 mt-2'>
              <div className={`w-1/2 text-center cursor-pointer p-1 rounded-md ${type === "daily" ? "bg-black text-[#FFCC00]" : "text-black"}`} onClick={() => setType("daily")}>
                Quotidien
              </div>
              <div className={`w-1/2 text-center cursor-pointer p-1 rounded-md ${type === "weekly" ? "bg-black text-[#FFCC00]" : "text-black"}`} onClick={() => setType("weekly")}>
                Hebdomadaire
              </div>
              <div className={`w-1/2 text-center cursor-pointer p-1 rounded-md ${type === "monthly" ? "bg-black text-[#FFCC00]" : "text-black"}`} onClick={() => setType("monthly")}>
                Mensuel
              </div>
            </div>

            {/* Weeks Display for Weekly */}
            {type === "weekly" && (
                <div className='flex'>
                  {weekData && weekData.map((item, idx) => (
                    <div
                      key={idx}
                      className={`w-[98%] border-2 py-1 mx-auto rounded-md px-2 mt-2 ${selectedWeek === item.name ? "bg-black text-[#FFCC00]" : "text-black bg-[#F2F2F2]"}`}
                      onClick={() => handleWeekChange(item)}
                    >
                      <h1 className="text-center cursor-pointer py-1 rounded-md text-base break-words">
                        {item.name}
                      </h1>
                    </div>
                  ))}
                </div>
              )}

            {/* Leaderboard */}
            <div className='hosted-page-body w-full mx-auto mt-2'>
              <div className='flex py-2 header-text rounded-t-md px-2 justify-between'>
                <div>Classement</div>
                <div>SCORE</div>
                <div>MSISDN</div>
              </div>

              {!sbData || sbData.length === 0 || status === "failed" ? (
                <div className='w-full mt-4'>
                  <img src={nodata} className='w-[30%] mx-auto' alt="nodata" />
                  <h1 className='text-center w-[90%] mx-auto mt-4'>
                    Actuellement, aucun gagnant n'est disponible. Restez à
                    l'écoute pour les prochains résultats !
                  </h1>
                  <div className='w-[90%] mx-auto cursor-pointer' onClick={() => navigate("/scoreboard")}>
                    <button className='w-full mt-6 bg-[#FFCC00] px-2 py-3 rounded-xl text-black font-semibold'>
                      Classement
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  {sbData.map((data) => (
                    <div
                      key={data.userId}
                      className={`grid py-4 px-1 mt-1 rounded-sm ${data.userId === msisdn ? 'bg-[#00678F] text-white' : 'bg-white text-black'}`}
                    >
                      <div className='content-text flex'>
                        <img src={rankIcon} className='w-7 h-7 pr-2' alt="rank"/>
                        <h1 className={`${data.userId === msisdn ? "text-white" : "text-black"}`}>{data?.id}</h1>
                      </div>
                      <div className={`content-text content-center ${data.userId === msisdn ? "text-white" : "text-black"}`}>{data.score}</div>
                      <div className={`content-text ${data.userId === msisdn ? "text-white" : "text-black"}`}>{changeToStar(data.userId)}</div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
}